import { cn } from '@/lib/utils';

interface LoadingPageProps {
  message?: string;
  className?: string;
}

export function LoadingPage({ message = 'Loading...', className }: LoadingPageProps) {
  return (
    <div
      className={cn(
        'min-h-[400px] flex flex-col items-center justify-center',
        className
      )}
      role="status"
      aria-live="polite"
    >
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-bc-teal border-t-transparent mb-4" />
      <p className="text-gray-500 text-sm mb-0">{message}</p>
      <span className="sr-only">{message}</span>
    </div>
  );
}
